export default "/assets/images/dark-moss.822e4cc920e94a84.webp";